<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="核实计划信息"
        :visible.sync="dialogVisible"
        width="800px"
        top="50px"
        :before-close="handleClose">
        <div class="body-content">
            <p>请 <span class="text-bold">检查核实</span> 调用计划的 <span class="text-bold">关键信息</span>，若发现有误请及时调整。</p>
            <p>核实完成后请勿再修改调用计划相关信息，若需修改，在修改后需要刷新页面重新选择该计划。</p>

            <div class="plan-content mt10" v-loading="dataLoading">
                <el-row class="mb20 row-info">
                    <el-col :span="24">
                        <span class="label-text text-color-gray">计划名称：</span> {{actionPlanInfo.plan_info.name||'--'}}（{{actionPlanInfo.plan_info.id}}）
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">推广目标：</span> {{getAdTypeText(actionPlanInfo.plan_info.adType)}}
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">计划预算：</span> <span class="text-color-error text-bold">
                          <!--计划日限额:不限额显示-1，有限额以毫分为单位显示，1元=100000毫分-->
                        <span v-if="actionPlanInfo.plan_info.dailyBudget==-1">不限</span>
                        <span v-else>
                             {{centToYuan(actionPlanInfo.plan_info.dailyBudget)}}
                        </span>
                        </span>
                    </el-col>
                </el-row>
                <el-row class="mb20 row-info" v-for="item in actionPlanInfo.group_info" :key="item.id">
                    <el-col :span="24">
                        <span class="label-text text-color-gray">广告组名称：</span> {{item.name||'--'}}（{{item.id||'--'}}）
                    </el-col>
                    <el-col :span="12" class="ellipsis">
                        <span class="label-text text-color-gray">投放应用：</span>
                        <span :title="item.app_name+'('+item.app_id+')'">
                             {{item.app_name||'--'}}（{{item.app_id||'--'}}）
                        </span>
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">日限额：</span>
                        {{centToYuan(item.dailyBudget)}}
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">出价方式：</span> {{getChargeTypeText(item.chargeType)}}
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">基础出价：</span> <span class="text-color-error text-bold">{{centToYuan(item.price)}}</span>
                    </el-col>
                    <!-- chargeType=='3'：出价类型为ocpc&&判断条件1 -->
                    <template v-if="item.chargeType=='3'&&(!item.cv3Type||item.cv3Type==0)&&(!item.ocpx3Price||item.ocpx3Price==0)">
                        <!--<el-col :span="12">-->
                            <!--<span class="label-text text-color-gray">过渡目标：</span> &#45;&#45;-->
                        <!--</el-col>-->
                        <!--<el-col :span="12">-->
                            <!--<span class="label-text text-color-gray">过渡出价：</span> &#45;&#45;-->
                        <!--</el-col>-->
                        <el-col :span="12">
                            <span class="label-text text-color-gray">优化目标：</span> {{getCvTypeText(item.cvType,'cvType')}}
                        </el-col>
                        <el-col :span="12">
                            <span class="label-text text-color-gray">优化出价：</span>
                            <span class="text-color-error text-bold">{{centToYuan(item.ocpxPrice)}}</span>
                        </el-col>
                    </template>
                    <!-- chargeType=='3'：出价类型为ocpc&&其他 -->
                    <template v-else-if="item.chargeType=='3'">
                        <!--<el-col :span="12">-->
                            <!--<span class="label-text text-color-gray">过渡目标：</span>-->
                            <!--<span>{{getCvTypeText(item.cvType,'cvType')}}</span>-->
                        <!--</el-col>-->
                        <!--<el-col :span="12">-->
                            <!--<span class="label-text text-color-gray">过渡出价：</span>-->
                            <!--<span class="text-color-error text-bold">{{centToYuan(item.ocpxPrice)}}</span>-->
                        <!--</el-col>-->
                        <el-col :span="12">
                            <span class="label-text text-color-gray">优化目标：</span> {{getCvTypeText(item.cv3Type,'cv3Type')}}
                        </el-col>
                        <el-col :span="12">
                            <span class="label-text text-color-gray">优化出价：</span>
                            <span class="text-color-error text-bold">{{centToYuan(item.ocpx3Price)}}</span>
                        </el-col>
                    </template>
                    <!-- chargeType!='3'：出价类型为非ocpc -->
                    <template v-else>
                        <!--<el-col :span="12">-->
                            <!--<span class="label-text text-color-gray">过渡目标：</span>-->
                            <!--<span>{{getCvTypeText(item.cvType,'cvType')}}</span>-->
                        <!--</el-col>-->
                        <!--<el-col :span="12">-->
                            <!--<span class="label-text text-color-gray">过渡出价：</span>-->
                            <!--<span v-if="!getCvTypeText(item.cvType,'cvType')||getCvTypeText(item.cvType,'cvType')=='-'||getCvTypeText(item.cvType,'cvType')=='&#45;&#45;'">&#45;&#45;</span>-->
                            <!--<span v-else class="text-color-error text-bold">{{centToYuan(item.ocpxPrice)}}</span>-->
                        <!--</el-col>-->
                        <el-col :span="12">
                            <span class="label-text text-color-gray">优化目标：</span> {{getCvTypeText(item.cv3Type,'cv3Type')}}
                        </el-col>
                        <el-col :span="12">
                            <span class="label-text text-color-gray">优化出价：</span>
                            <span v-if="!getCvTypeText(item.cv3Type,'cv3Type')||getCvTypeText(item.cv3Type,'cv3Type')=='-'||getCvTypeText(item.cv3Type,'cv3Type')=='--'">--</span>
                            <span v-else class="text-color-error text-bold">{{centToYuan(item.ocpx3Price)}}</span>
                        </el-col>
                    </template>

                    <el-col :span="12">
                        <span class="label-text text-color-gray">深度优化目标：</span> {{getCvTypeText(item.secondCvType,'secondCvType')}}
                    </el-col>
                    <el-col :span="12">
                        <span class="label-text text-color-gray">深度优化出价：</span>
                        <span v-if="!getCvTypeText(item.secondCvType,'secondCvType')||getCvTypeText(item.secondCvType,'secondCvType')=='-'||getCvTypeText(item.secondCvType,'secondCvType')=='--'">--</span>
                        <span v-else class="text-color-error text-bold">{{centToYuan(item.secondOcpxPrice)}}</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac mb20">
            <el-button type="primary" :disabled="dataLoading" class="confirm-btn" @click="confirmPlan">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/marketManage/vivoBatch';

    export default {
        name: "CheckPlanModal",
        props:{
            planId:[String,Number],
            accountId:[String,Number],
        },
        data(){
            return {
                dialogVisible:false,
                actionPlanInfo:{
                    plan_info:{},
                    group_info:[
                        {},
                    ],
                    task_id:'',
                },
                dataLoading:false,
                hasGroupTargetId:null,
            }
        },
        methods:{
            handleClose(){
                this.dialogVisible = false;
                this.dataLoading = false;
                this.hasGroupTargetId = null;
                this.actionPlanInfo = {
                    plan_info:{},
                    group_info:[
                        {},
                    ],
                    task_id:'',
                };
            },
            showModal(){
                this.dialogVisible = true;
            },
            checkPlanInfo(){
                if(!this.planId) return false;
                this.dataLoading = true;
                API.getPlanDetailInfo({
                    account_id:this.accountId,
                    plan_id:this.planId,
                }).then(res=>{
                    this.dataLoading = false;
                    let resData = res.data||{};

                    this.actionPlanInfo.ad_info = resData.ad_info||[];
                    this.actionPlanInfo.group_info = resData.group_info||[];
                    this.actionPlanInfo.plan_info = resData.plan_info||{};
                    this.actionPlanInfo.task_id = resData.task_id;
                    this.actionPlanInfo.map = resData.map;

                    this.hasGroupTargetId = (resData.group_info||[]).some(item=>{
                        let audienceInfo = item.audienceDto||{};
                        let customList = audienceInfo.customList||[];
                        return Array.isArray(customList)&&customList.length>0;
                    });

                    this.showModal();
                    this.$emit('update');
                },err=>{
                    console.log('getPlanDetailInfo err',err);
                    this.dataLoading = false;
                    this.$message.error(err.info||'操作失败');
                    this.handleClose();
                    this.$emit('update');
                })
            },
            confirmPlan(){

                let groupInfos = this.actionPlanInfo.group_info||[];
                let groupPrices = groupInfos.map(item=>{
                    // 取 优化出价
                    if(item.chargeType=='3'&&(!item.cv3Type||item.cv3Type==0)&&(!item.ocpx3Price&&item.ocpx3Price==0)){
                        return this.centToYuan(item.ocpxPrice);
                    }else{
                        return this.centToYuan(item.ocpx3Price);
                    }
                });
                let isHasLowPrice = groupPrices.some(item=>!isNaN(item)&&item>0&&item<1);
                if(isHasLowPrice){
                    let htmlStr = '<p>您当前优化目标出价低于<span class="text-color-error">1元</span>，请确认核实，以免创建失败！！</p>';
                    this.$confirm(htmlStr,'温馨提示',{
                        confirmButtonText: '已确认',
                        cancelButtonText: '关闭',
                        dangerouslyUseHTMLString: true,
                        type: 'warning',
                    }).then(()=>{
                        this.$emit('confirm',{
                            hasGroupTargetId:this.hasGroupTargetId,
                            taskId:this.actionPlanInfo.task_id,
                            appId:(groupInfos[0]||{}).app_id,
                            isAimedia: this.actionPlanInfo.plan_info.mediaType === 15
                        });
                        this.handleClose();
                    })
                }else{
                    this.$emit('confirm',{
                        hasGroupTargetId:this.hasGroupTargetId,
                        taskId:this.actionPlanInfo.task_id,
                        appId:(groupInfos[0]||{}).app_id,
                        isAimedia: this.actionPlanInfo.plan_info.mediaType === 15
                    });
                    this.handleClose();
                }
            },
            getAdTypeText(type){
                let map = this.actionPlanInfo.map||{};
                let dataMap = map.adType||[];
                let actionItem = dataMap.find(item=>item.id == type);
                return actionItem?actionItem.name:'--';
            },
            getChargeTypeText(type){
                let map = this.actionPlanInfo.map||{};
                let dataMap = map.chargeType||[];
                let actionItem = dataMap.find(item=>item.id == type);
                return actionItem?actionItem.name:'--';
            },
            getCvTypeText(type,field){
                let map = this.actionPlanInfo.map||{};
                let dataMap = map[field]||[];
                let actionItem = dataMap.find(item=>item.id == type);
                return actionItem?actionItem.name:'--';
            },
            centToYuan(num){
                // 1元=100000毫分
                if(!num||isNaN(num)) return num;
                let newNum = +num;
                if(num===0) return 0;
                if(num==-1) return '不限';
                if(num%100000!=0){
                    return (newNum/100000).toFixed(2);
                }else{
                    return newNum/100000;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .plan-content{
        border: solid 1px #dcdee2;
        height: 300px;
        overflow-y: auto;
        padding: 20px;
        font-size: 12px;
    }
    .row-info{
        background-color: #f8f8f9;
        padding: 10px 20px;
        border-radius: 3px;
        line-height: 28px;
    }
    .label-text{
        display: inline-block;
        width: 8em;
        text-align: right;
        margin-right: 20px;
    }

    .confirm-btn{
        width: 150px;
    }
</style>
